import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import DrawerMenu from '../DrawerMenu/DrawerMenu';
import { Wrapper, Container, Left, Center, Right, LogoCenter, LogoBlack, PrevIcon, PrevText } from './GlobalNavi.style';
import logo from '../../../assets/images/sp-logo-black.svg';
import IconBack from '../assets/back.svg';
import IconHamburger from '../assets/hamburger.svg';
import SublimicLogo from '../assets/sublimic-logo.svg';
import Placeholder from '../../Placeholder';

import { reducer, state } from '../../../redux/sagas/aws-cognito-redux-saga';
// import { getCurrentDiagnosisUser } from '../../../redux/selectors/hairDiagnosis';
import { resetCurrentDiagnosisUser } from '../../../redux/actions/hairDiagnosis';
import { fetchUser, clearCurrentUser } from '../../../redux/actions/user';
import fechSpAuthSalonSettings from '../../../redux/actions/authSalonSettings';

class GlobalNavi extends React.Component {
  state = {
    drawerMenu: {
      isOpen: false,
    },
    scrolled: false,
    isSignedIn: false,
  };

  componentWillMount() {
    this.setAuthStatus();
  }

  componentDidMount() {
    window.addEventListener('scroll', () => this.watchCurrentPosition(), false);
    const { stylist, auth, fetchUser, location } = this.props;
    this.getUserData({ stylist, auth, fetchUser, location });
  }

  componentWillReceiveProps(nextProps) {
    const { stylist, auth, fetchUser, location } = nextProps;
    if (auth.isSignedIn === state.AUTH_SUCCESS && !stylist.family_name) {
        this.getUserData({ stylist, auth, fetchUser, location });
    }
    this.setAuthStatus(auth);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', () => this.watchCurrentPosition(), false);
  }

  setAuthStatus = a => {
    const auth = a || this.props.auth;
    this.setState({ isSignedIn: auth.isSignedIn === state.AUTH_SUCCESS });
  };
  getUserData = props => {
    const { auth, stylist, fetchUser, location } = props;
    if (
      auth &&
      auth.info &&
      auth.info.username &&
      !stylist.family_name &&
      ['login', 'forgot-password', 'change-password', 'sign-up'].every(el => !location.pathname.includes(el))
    ) {
      fetchUser(auth.info.username).then(({ value }) => {
        this.props.getSpauthSeting(value.user.salonId);
      });
    }
  };

  getService = () => {
    const path = window.location.pathname.split('/');
    if (path[3] === 'sublimic') {
      return 'sublimic';
    }
    return '';
  };

  watchCurrentPosition = () => {
    const currentPosition = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
    // if (currentPosition > 0 && !this.state.scrolled) {
    //   this.setState({ scrolled: true });
    // } else if (currentPosition <= 100 && this.state.scrolled) {
    //   this.setState({ scrolled: false });
    // }
    if (currentPosition > 40) {
      this.setState({ scrolled: true });
    } else {
      this.setState({ scrolled: false });
    }
  };

  useCamera = () => {
    const { authSalonSettings } = this.props;
    if (authSalonSettings && authSalonSettings.others && authSalonSettings.others.useCamera) {
      return authSalonSettings.others.useCamera.toLowerCase() === 'true' ? true : false;
    }
    return false;
  };

  prev = () => {
    const { history, locale } = this.props;
    const path = window.location.pathname;
    const useCamera = !!this.useCamera();
    const skippedUserSurvey = !!localStorage.getItem('sublimic-skippedUserSurvey');
    const useDiagnosis = localStorage.getItem('useDiagnosis') === 'yes' ? true : false;

    if (RegExp('/salon-consultation/sublimic/salon-program').test(path)) {
      history.goBack();
    } else if (RegExp('/salon-consultation/sublimic/homecare').test(path)) {
      const paths = path.split('/');
      if (paths[5] && paths[5].length > 0) {
        if (paths[6] && paths[6] === 'step') {
          history.goBack();
        } else {
          history.push(`/${locale}/salon-consultation/sublimic/homecare`);
        }
      } else {
        history.push(`/${locale}/salon-consultation/sublimic/home`);
      }
    } else if (RegExp('/salon-consultation/sublimic/home').test(path)) {
      history.push(`/${locale}/salon-consultation/home`);
    }
    if (RegExp('/salon-consultation/sublimic/diagnosis').test(path)) {
      history.push(`/${locale}/salon-consultation/sublimic/home`);
    }
    if (RegExp('/salon-consultation/sublimic/diagnosis/user-survey').test(path)) {
      history.push(`/${locale}/salon-consultation/sublimic/diagnosis`);
    }
    if (RegExp('/salon-consultation/sublimic/diagnosis/scalp-camera').test(path)) {
      if (skippedUserSurvey) {
        history.push(`/${locale}/salon-consultation/sublimic/diagnosis`);
      } else {
        history.push(`/${locale}/salon-consultation/sublimic/diagnosis/user-survey`);
      }
    }
    if (RegExp('/salon-consultation/sublimic/diagnosis/stylist-diagnosis').test(path)) {
      // TODO: スカルプカメラ連携は Phase 2 対象外。以下の処理は、後で必要があれば復活させる。
      // if (!useCamera && skippedUserSurvey) {
      //   history.push(`/${locale}/salon-consultation/sublimic/diagnosis`);
      // } else if (!useCamera && !skippedUserSurvey) {
      //   history.push(`/${locale}/salon-consultation/sublimic/diagnosis/user-survey`);
      // } else {
      //   history.push(`/${locale}/salon-consultation/sublimic/diagnosis/scalp-camera`);
      // }

      if (skippedUserSurvey) {
        history.push(`/${locale}/salon-consultation/sublimic/diagnosis`);
      } else {
        history.push(`/${locale}/salon-consultation/sublimic/diagnosis/user-survey`);
      }
    }
    if (RegExp('/salon-consultation/sublimic/diagnosis/result/top').test(path)) {
      if (useDiagnosis) {
        history.push(`/${locale}/salon-consultation/sublimic/diagnosis/stylist-diagnosis`);
      } else {
        history.push(`/${locale}/salon-consultation/sublimic/diagnosis/quick-diagnosis`);
      }
    }
    if (RegExp('/salon-consultation/sublimic/diagnosis/result/hair-care').test(path)) {
      history.push(`/${locale}/salon-consultation/sublimic/diagnosis/result/top`);
    }
    if (RegExp('/salon-consultation/sublimic/diagnosis/result/scalp-care').test(path)) {
      history.push(`/${locale}/salon-consultation/sublimic/diagnosis/result/hair-care`);
    }
    if (RegExp('/salon-consultation/sublimic/diagnosis/result/confirm').test(path)) {
      history.push(`/${locale}/salon-consultation/sublimic/diagnosis/result/scalp-care`);
    }
  };

  openMenu = () => {
    this.setState({
      drawerMenu: { isOpen: true },
    });
  };

  closeMenu = () => {
    this.setState({
      drawerMenu: { isOpen: false },
    });
  };

  isSublimicHome = () => {
    const path = window.location.pathname;

    if (RegExp('/salon-consultation/sublimic/home$').test(path)) {
      return true;
    }
    return false;
  };

  render() {
    const { locale, copy, screenSize } = this.props;
    const commonCopy = copy.common || {};
    const { drawerMenu, isSignedIn } = this.state;
    const service = this.getService();
    const isSublimicHomeFlg = this.isSublimicHome();
    const leftLogoSize = {
      width: screenSize === 0 ? '75px' : '170px',
      height: screenSize === 0 ? '30px' : '54px',
    };

    return (
      <React.Fragment>
        <Wrapper
          style={{
            backgroundColor: this.state.scrolled ? '#ffffff' : 'transparent',
            transitionProperty: 'background-color',
            transitionDuration: '0.2s',
          }}
          id="globalNavi"
        >
          <Container>
            {(() => {
              if (service === 'sublimic') {
                return (
                  <React.Fragment>
                    <Left onClick={this.prev}>
                      <PrevIcon src={IconBack} />
                      {commonCopy.back ? (
                        <PrevText>{commonCopy.back}</PrevText>
                       ) : (
                        <Placeholder w="60px" h="32px" />
                       )
                      }
                    </Left>
                    <Center>
                      <LogoCenter className={isSublimicHomeFlg && `isSublimicHome`} src={SublimicLogo} />
                    </Center>
                    <Right onClick={this.openMenu}>
                      <img src={IconHamburger} alt="menu" />
                    </Right>
                  </React.Fragment>
                );
              }
              return (
                <React.Fragment>
                  <Left className="has-logo">
                    {isSignedIn ? (
                      <Link
                        to={`/${locale}/salon-consultation/home`}
                        href={`/${locale}`}
                        style={{ position: 'relative', ...leftLogoSize }}
                      >
                        <LogoBlack src={logo} white={false} />
                      </Link>
                    ) : (
                      <LogoBlack src={logo} white={false} />
                    )}
                  </Left>
                  <Center />
                  {isSignedIn && (
                    <Right onClick={this.openMenu}>
                      <img src={IconHamburger} alt="menu" />
                    </Right>
                  )}
                </React.Fragment>
              );
            })()}
          </Container>
        </Wrapper>
        <DrawerMenu isOpen={drawerMenu.isOpen} copy={copy} locale={locale} closeMenu={this.closeMenu} />
      </React.Fragment>
    );
  }
}

GlobalNavi.defaultProps = {
  copy: {},
  authSalonSettings: {},
};
GlobalNavi.propTypes = {
  copy: PropTypes.shape({}),
  locale: PropTypes.string.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  location: PropTypes.shape().isRequired,
  fetchUser: PropTypes.func.isRequired,
  getSpauthSeting: PropTypes.func.isRequired,
  auth: PropTypes.shape({}).isRequired,
  screenSize: PropTypes.number.isRequired,
  stylist: PropTypes.shape({}).isRequired,
  authSalonSettings: PropTypes.shape(),
};

const mapState = state => ({
  locale: state.locale,
  auth: state.auth,
  screenSize: state.screenSize,
  stylist: state.user,
  copy: state.salonConsultaionSiteOptions.siteCopy,
  authSalonSettings: state.authSalonSettings,
});

const mapDispatch = dispatch => ({
  signOut: () => dispatch(reducer.signOut()),
  resetCurrentDiagnosisUser: () => dispatch(resetCurrentDiagnosisUser()),
  fetchUser: username => dispatch(fetchUser(username)),
  clearCurrentUser: () => dispatch(clearCurrentUser()),
  getSpauthSeting: salonId => dispatch(fechSpAuthSalonSettings(salonId)),
});

export default connect(mapState, mapDispatch)(GlobalNavi);



// WEBPACK FOOTER //
// ./src/components/SalonConsultation/GlobalNavi/GlobalNavi.js